import type { ChipProps } from "@mui/material";

export enum ScraperStatus {
  Active = "active",
  Paused = "paused",
  Error = "error",
}

/** Maps scraper status to MUI Chip color for list and dashboard views. */
export const SCRAPER_STATUS_CHIP_COLOR: Record<
  string,
  NonNullable<ChipProps["color"]>
> = {
  [ScraperStatus.Active]: "success",
  [ScraperStatus.Error]: "error",
  [ScraperStatus.Paused]: "warning",
};
